import Stomp from 'stompjs';
import store from "@/store/index.js";

let stompClient = null;
let isConnected = false;
let message = null;
const subscribers = [];

export function connect() {
    const socket = new WebSocket(process.env.VUE_APP_WEBSOCKET_BASE_URL);
    stompClient = Stomp.over(socket);

    stompClient.debug = (str) => { console.log(str); };
    const accessToken = sessionStorage.getItem('accessToken');
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    stompClient.connect(headers, () => {
        isConnected = true;
        stompClient.subscribe('/firefly/events', (message) => {
            const parsedMessage = JSON.parse(message.body);
            subscribers.forEach(callback => callback(parsedMessage));
        });
    }, (error) => {
        isConnected = false;
        console.log("isconnected in connect :", isConnected);
        console.error('Connection error:', error);
        reconnect();
    });
}
export function reconnect() {
    console.log("isconnected in reconnect:", isConnected);
    setTimeout(() => {
        if (!isConnected) {
            console.log('Reconnecting...');
            connect(message);
        } else {
            console.log('Already connected. Skipping reconnect.');
        }
    }, 30000);
}

export function send(command) {
    if (isConnected && stompClient) {
        console.log("Sending command: " + command);
        stompClient.send('/app/status', {}, JSON.stringify({ command }));
    } else {
        console.error('Cannot send message: WebSocket is not connected');
        store.dispatch("authStore/checkAndRefreshTokenIfNeeded");
    }
}
export function registerSubscriber(callback) {
    subscribers.push(callback);
}
export function disconnect() {
    if (stompClient !== null) {
        stompClient.disconnect(() => {
            console.log('Disconnected');
            subscribers = [];
        });
    }
}
